import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Feed } from 'src/app/models/Feed';
import { Marriage } from 'src/app/models/Marriage';
import { AuthService } from 'src/app/services/auth.service';
import { FeedService } from 'src/app/services/modelService/feed.service';
import { ReactionService } from 'src/app/services/modelService/reaction.service';

@Component({
  selector: 'app-marriage',
  templateUrl: './marriage.component.html',
  styleUrls: ['./marriage.component.scss'],
})
export class MarriageComponent implements OnInit {
  @Input() details = false;
  
  @Input() feed: Feed = new Marriage();
  @Output() openDetails = new EventEmitter<string>();
  showEmojiBox: boolean = false;
  isLiked: boolean = false;
  constructor(public reactionService: ReactionService,
    public feedService: FeedService,
    private auth: AuthService,
    private router: Router) { }

  ngOnInit() {
    this.auth.getLoggedInEmployee();
    this.feedService.feed = this.feed;
  }

  clickEmoji(emoji) {
    this.showEmojiBox = false;
    this.reactionService.reaction.reaction = emoji;
    console.log(this.reactionService.reaction);
    this.feedService.sendMessage(this.feed);
  }
  
  onImageError(event: any) {
    event.target.src = './assets/imgs/feed_marriage.png';
  }
  
  toggleLike() {
    this.isLiked = !this.isLiked; // Toggle the like state
  }
}
